import { analytics, logEvent } from '../config/firebase';

/**
 * Track a page view event
 * @param pageName The name of the page being viewed
 * @param pageParams Additional parameters to include with the event
 */
export const trackPageView = (pageName: string, pageParams: Record<string, any> = {}) => {
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...pageParams
  });
};

/**
 * Track a click event
 * @param elementName The name of the element that was clicked
 * @param elementParams Additional parameters to include with the event
 */
export const trackClick = (elementName: string, elementParams: Record<string, any> = {}) => {
  logEvent(analytics, 'select_content', {
    content_type: 'button',
    content_id: elementName,
    ...elementParams
  });
};

/**
 * Track a custom event
 * @param eventName The name of the custom event
 * @param eventParams Additional parameters to include with the event
 */
export const trackEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
  logEvent(analytics, eventName, eventParams);
};

/**
 * Track when a user views a specific project
 * @param projectName The name of the project being viewed
 * @param projectUrl The URL of the project
 */
export const trackProjectView = (projectName: string, projectUrl: string) => {
  logEvent(analytics, 'view_item', {
    item_id: projectName,
    item_name: projectName,
    item_category: 'project',
    item_url: projectUrl
  });
};

/**
 * Track when a user plays an audio track
 * @param trackName The name of the audio track
 */
export const trackAudioPlay = (trackName: string) => {
  logEvent(analytics, 'play_audio', {
    audio_name: trackName,
    content_type: 'audio'
  });
}; 